var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12 9.28C4.45867 8.49067 3.76533 7.808 3.04 7.232C2.336 6.63467 1.58933 6.144 0.8 5.76V4.384C2.37867 3.57333 3.81867 2.38933 5.12 0.831999H7.584C7.34933 1.45067 7.072 2.03733 6.752 2.592C6.45333 3.12533 6.13333 3.63733 5.792 4.128V6.016C6.13333 6.464 6.45333 6.96533 6.752 7.52C7.072 8.05333 7.34933 8.64 7.584 9.28H5.12ZM5.6 6.368L5.632 3.744H23.2V6.368H5.6Z",
    fill: "#282828"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.efbe3b8bf06044af58af99bf473019cb.svg";
export { ForwardRef as ReactComponent };